'use client';

import HoverPrefetchLink from '@/components/hover-prefetch-link';
import Price from '@/components/Price';
import Rate from '@/components/Rate';
import Image from 'next/image';
import { useRef } from 'react';

const BestSeller = ({ products }) => {
  const containerRef = useRef(null);
  // 用 ref 存储拖拽状态，避免每次渲染重新创建
  const dragState = useRef({ isDragging: false, startX: 0, scrollLeft: 0, offsetLeft: 0 });

  const handleMouseDown = e => {
    const el = containerRef.current;
    if (!el) return;
    // 先读取几何属性（避免写后读导致强制重排）
    const offsetLeft = el.offsetLeft;
    const scrollLeftVal = el.scrollLeft;
    // 再写入样式
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
    dragState.current = { isDragging: true, startX: e.pageX - offsetLeft, scrollLeft: scrollLeftVal, offsetLeft };
  };

  const handleMouseLeave = () => {
    const el = containerRef.current;
    if (!el) return;
    dragState.current.isDragging = false;
    el.style.cursor = 'grab';
    el.style.userSelect = '';
  };

  const handleMouseUp = () => {
    const el = containerRef.current;
    if (!el) return;
    dragState.current.isDragging = false;
    el.style.cursor = 'grab';
    el.style.userSelect = '';
  };

  const handleMouseMove = e => {
    const { isDragging, startX, scrollLeft, offsetLeft } = dragState.current;
    if (!isDragging) return;
    e.preventDefault();
    // 复用 mousedown 时缓存的 offsetLeft，避免每帧强制重排
    const x = e.pageX - offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className='mt-[60px] px-[17px] lg_px-0'>
      <div className='mx-auto w-[1440px] max-w-full'>
        <h2 className='mb-[30px] flex items-end justify-between font-poppins text-[22px] font-[600] leading-[1.4] text-title lg_text-[30px]'>
          Shop Best Sellers
          <div>
            <HoverPrefetchLink
              href='/bird-feeders?sort_by=best_sellers'
              className='font-sans text-[16px] font-normal uppercase text-primary underline'
            >
              <span className='lg_hidden'>View All</span>
              <span className='hidden lg_inline'>View All Best Sellers</span>
            </HoverPrefetchLink>
          </div>
        </h2>

        <div className='w-full'>
          <div
            id='scroll-container'
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            className='flex overflow-x-auto whitespace-nowrap pb-[30px]'
          >
            {products.map((product, index) => (
              <div
                className='mr-[12px] w-[calc(50%-6px)] shrink-0 select-none lg_mr-[30px] lg_w-[320px]'
                key={index}
              >
                <HoverPrefetchLink
                  href={'/' + product.url_key + '.html'}
                  className='flex flex-col'
                  key={product.uid}
                  draggable={false}
                >
                  <Image
                    draggable={false}
                    width={320}
                    height={320}
                    src={product.image.url}
                    alt={product.name}
                    className=' hover_shadow h-auto w-full cursor-pointer select-none'
                  />

                  <p
                    draggable={false}
                    className='mb-[5px] mt-[10px] select-none whitespace-normal font-sans text-sm text-title lg_text-[16px]'
                  >
                    {product.name}
                  </p>

                  <p className='mb-[10px] flex items-center justify-start'>
                    <span className='select-none font-poppins text-[16px] font-[600] leading-[1.4] text-title lg_text-[20px]'>
                      <Price
                        currencyCode={product.price_range.minimum_price.final_price.currency}
                        value={product.price_range.minimum_price.final_price.value}
                      />
                    </span>
                    <span className='ml-[5px] hidden select-none font-sans text-sm font-[600] text-[#ADADAD] line-through lg_block'>
                      {product.price_range.minimum_price.discount.amount_off !== 0 ? (
                        <Price
                          currencyCode={product.price_range.minimum_price.regular_price.currency}
                          value={product.price_range.minimum_price.regular_price.value}
                        />
                      ) : null}
                    </span>
                  </p>

                  <div className='flex items-center'>
                    <Rate
                      disabled
                      initialRating={product.rating_summary / 20}
                    />
                    <span className='ml-[10px] select-none font-sans text-sm leading-[1.4] text-[#666]'>
                      {product.review_count} <span className='hidden lg_inline-block'>Reviews</span>
                    </span>
                  </div>
                </HoverPrefetchLink>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestSeller;
